export const METADATA_BLOCK_CONSTANTS = {
	DEFAULT_MAX_LINES: 2,
	MAXIMUM_MAX_LINES: 2,
	MINIMUM_MAX_LINES: 1,
} as const;
